import { CSSProperties, FC } from 'react';
import Lottie from 'lottie-react';
import styled from '@emotion/styled';
import { ifProp } from 'styled-tools';
import legekaedenSpinnerData from '$assets/legekaeden-spinner.json';

export type LegeKaedenSpinnerProps = {
    center: boolean;
};

export const LegeKaedenSpinner: FC<LegeKaedenSpinnerProps> = (props) => (
    <SpinnerContainer center={props.center}>
        <Lottie animationData={legekaedenSpinnerData} loop={true} style={legeKaedenAnimationStyle} />
    </SpinnerContainer>
);

const legeKaedenAnimationStyle: CSSProperties = {
    maxWidth: '70px',
};

const SpinnerContainer = styled.div<{ center: boolean }>(
    () => ({
        display: 'inline-block',
    }),
    ifProp('center', ({ theme }) => ({
        position: 'fixed',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        display: 'flex',
        /* flex-grow: 1; */
        zIndex: theme.zIndices.loadingSpinner,
        alignItems: 'center',
        justifyContent: 'center',
    }))
);
